"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mapper = void 0;
class Mapper {
    /**
     * Map input array or object recursively from snake_case or kebab-case to camelCase
     * @param value
     * @returns
     */
    mapToCamel(value) {
        if (this.isObject(value)) {
            const obj = {};
            Object.keys(value).forEach((key) => {
                obj[this.toCamel(key)] = this.mapToCamel(value[key]);
            });
            return obj;
        }
        else if (this.isArray(value)) {
            return value.map((val) => {
                return this.mapToCamel(val);
            });
        }
        return value;
    }
    ;
    /**
     * Is value an object
     */
    isObject(value) {
        return value === Object(value) && !this.isArray(value) && typeof value !== 'function';
    }
    ;
    /**
     * Is value an array
     */
    isArray(value) {
        return Array.isArray(value);
    }
    ;
    /**
     * Convert to camel case
     */
    toCamel(key) {
        return key.replace(/([-_][a-z])/ig, ($1) => {
            return $1.toUpperCase()
                .replace('-', '')
                .replace('_', '');
        });
    }
    ;
}
exports.Mapper = Mapper;
